import { useEffect, useState } from 'react'

/**
 * L'écran est-il trop étroit pour la mise en page d'origine ?
 *
 * ────────────────────────────────────────────────────────────────────────────
 * Pourquoi 1000 pixels, et pourquoi un hook plutôt qu'une media query seule
 * ────────────────────────────────────────────────────────────────────────────
 *
 * L'application a été dessinée pour l'iPad, où la caisse pose côte à côte le
 * pavé et le ticket. En dessous de mille pixels, les deux ne tiennent plus : un
 * iPhone 15 ou 17 fait 393 points de large, un Pro Max 430. Il ne s'agit donc
 * pas de rétrécir mais de **choisir** ce qu'on montre — et un choix se pilote
 * en JavaScript, pas en CSS : il faut un état, des boutons pour en changer, et
 * un ticket qui redevient visible tout seul quand on encaisse.
 *
 * Le reste de l'adaptation — barre de navigation, en-têtes, tableaux — se règle
 * bien en `@media`, et n'a pas besoin de ce hook.
 */
export const LARGEUR_ETROITE = 1000

export function useEtroit(): boolean {
  const [etroit, setEtroit] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < LARGEUR_ETROITE,
  )

  useEffect(() => {
    const requete = window.matchMedia(`(max-width: ${LARGEUR_ETROITE - 1}px)`)
    const majuscule = (e: MediaQueryListEvent | MediaQueryList) => setEtroit(e.matches)
    majuscule(requete)
    // Une rotation d'iPhone change la réponse en cours de vente.
    requete.addEventListener('change', majuscule)
    return () => requete.removeEventListener('change', majuscule)
  }, [])

  return etroit
}
